import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader

import { Box } from '@mui/material';
import { imageHelper } from 'common/functions/image-helper';
import { ListingImage } from 'graphql/generated';
import React from 'react';
import { Carousel } from 'react-responsive-carousel';

type Props = {
  images: ListingImage[];
};

const ImageCarousel = (props: Props) => {
  return (
    <Box
      sx={{
        '& .carousel .slide .legend': {
          width: '48px',
          left: '48%',
          bottom: 0,
        },
        '& .carousel .thumbs': {
          marginBlockStart: 0,
          marginBlockEnd: 0,
          // paddingLeft: 0,
        },
        // '& .carousel .thumb': {
        //   width: '114px !important',
        // },
        '& .carousel .thumbs-wrapper': {
          marginTop: 1,
          marginBottom: 1,
        },
      }}
    >
      <Carousel infiniteLoop>
        {props.images.map((x, idx) => (
          <div key={`photo-grid${idx.toString()}`}>
            <img src={imageHelper.getLocation(x)} alt="car" />
            {/* <p className="legend">{`${(idx + 1).toString()}/${props.images.length.toString()}`}</p> */}
          </div>
        ))}
      </Carousel>
    </Box>
  );
};

export default ImageCarousel;
